import { render } from "./wanadev-loader-view.vue?vue&type=template&id=43c0a754"
import script from "./wanadev-loader-view.vue?vue&type=script&lang=js"
export * from "./wanadev-loader-view.vue?vue&type=script&lang=js"

import "./wanadev-loader-view.vue?vue&type=style&index=0&id=43c0a754&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__